export const handleMailClick = (e) => {
    e.stopPropagation();
  const email = "officialpratik.99@gmail.com";
  const subject = "Hey Pratik!";
  const body = "Just visited your portfolio...";
  window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
};
